PopOverListasCtrl.$inject = ['$log', '$http', '$q'];

export default function PopOverListasCtrl($log, $http, $q) {
    var pol = this;

    pol.loading = true;
    pol.listas = [];

    pol.order_recent = window.localStorage.getItem("lst_order_recent");
    if (pol.order_recent == null)
        pol.order_recent = false;
    else
        pol.order_recent = (pol.order_recent == 'true');

    pol.abrir_blank = window.localStorage.getItem("lst_open_blnk");
    if (pol.abrir_blank == null)
        pol.abrir_blank = false;
    else
        pol.abrir_blank = (pol.abrir_blank == 'true');

    pol.searchText = '';
    pol.btnRecargar = false;

    var urlBase = Sigo.var.path + '/api/v1/usuarios/' + Sigo.user.user_id + "/listas";
    var urlBaseObLista = Sigo.var.path + '/obras/listas/';
    var urlBaseLista = Sigo.var.path + '/listas/';

    cargarListas();

    function cargarListas() {
        pol.loading = true;
        $http.get(urlBase + "?search=" + pol.searchText + "&order_recent=" + pol.order_recent).then(function (data) {
            pol.loading = false;
            pol.btnRecargar = false;
            pol.listas = data.data;
        }, function () {
            pol.loading = false;
        });
    }

    pol.reload = function () {
        pol.btnRecargar = true;
        cargarListas();
    };

    pol.nuevaLista = function () {
        Sigo.Listas.add(undefined, "angular").then(function () {
            pol.reload();
        });
    };

    pol.abrirLista = function (id) {
        if (pol.abrir_blank)
            window.open(urlBaseObLista + id, '_blank');
        else
            window.location.replace(urlBaseObLista + id);
    };

    pol.chgBlnk = function () {
        window.localStorage.setItem("lst_open_blnk", pol.abrir_blank);
    };

    pol.chgOrdRece = function () {
        window.localStorage.setItem("lst_order_recent", pol.order_recent);
        pol.reload();
    };

    pol.abrirListas = function () {
        if (pol.abrir_blank)
            window.open(urlBaseLista, '_blank');
        else
            window.location.replace(urlBaseLista);
    };

}